import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { Scenario } from 'src/app/core/_models/scenario';
import { ProjectService } from 'src/app/core/_services/project.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { SpinnerOverlayService } from '../../../core/_services/spinner.overlay.service';

@Component({
  selector: 'app-dialog-check-scenario-datas',
  templateUrl: './dialog-check-scenario-datas.component.html',
  styleUrls: ['./dialog-check-scenario-datas.component.scss']
})
export class DialogCheckScenarioDatasComponent implements OnInit {
  columnsInputProducts: string[] = [];
  columnsVehicles: string[] = [];
  columnsDredging: string[] = [];
  columnsTunneling: string[] = [];
  columnsOutputProducts: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogCheckScenarioDatasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectService: ProjectService,
    private spinnerService: SpinnerOverlayService,
    private snackbarService: SnackbarService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.columnsInputProducts = [
      this.translate.instant('column_input_products'),
      this.translate.instant('column_quantity'),
      this.translate.instant('column_work_unit'),
      this.translate.instant('column_density'),
      this.translate.instant('column_unit_environmental_cost'),
      this.translate.instant('column_routing')
    ];
    this.columnsVehicles = [this.translate.instant('column_vehicles'), this.translate.instant('column_quantity'), this.translate.instant('column_unit_environmental_cost')];
    this.columnsDredging = [this.translate.instant('common_field_dredging'), this.translate.instant('common_field_duration'), this.translate.instant('column_unit_environmental_cost')];
    this.columnsTunneling = [this.translate.instant('common_field_tunneling'), this.translate.instant('common_field_energy'), this.translate.instant('common_field_duration'), this.translate.instant('column_unit_environmental_cost')];
    this.columnsOutputProducts = [
      this.translate.instant('column_output_products'),
      this.translate.instant('column_quantity'),
      this.translate.instant('column_work_unit'),
      this.translate.instant('column_density'),
      this.translate.instant('column_unit_environmental_cost'),
      this.translate.instant('column_routing')
    ];
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  exportExcel(scenario: Scenario): void {
    this.spinnerService.show();
    this.projectService.getSynthesisVerificationDataExcel(scenario).subscribe(
      (file) => {
        const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([file], { type: contentType });
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute('download', scenario.displayName + ' - Synthèse - Données.xlsx');
        document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      () => {
        this.snackbarService.open(SnackbarTypes.error);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }
}
